import { createBroadcastEvent } from '@h5s/util-broadcast';

export const APP_UPDATED_EVENT = createBroadcastEvent('APP_UPDATED_EVENT');
